import React, { useState, memo } from 'react';
import { useSidebarEffects } from '../../../core/hooks/useSidebarEffects';
import ClientWidget from 'components/artectum/widgets/ClientWidget';
import FormWidget from 'components/artectum/widgets/FormWidget';
import TopRatedProductWidget from 'components/artectum/widgets/TopRatedProductWidget';


const SidebarDetails = memo(({ publicUrl, data }) => {
    const [isOpen, setIsOpen] = useState(false);
    useSidebarEffects(isOpen, setIsOpen);

    const handleOverlayClick = () => setIsOpen(false);
    const toggleSidebar = () => setIsOpen(prev => !prev);

    return (
        <div className="col-lg-4 mt-5">
            {isOpen && <div className="sidebar-overlay" onClick={handleOverlayClick} />}
            <button
                className={`sidebar-toggle-btn d-lg-none ${isOpen ? 'hidden' : ''}`}
                onClick={toggleSidebar}
            >
                <i className="fas fa-bars me-2" />
                Detalles
            </button>
            <aside className={`sidebar ltn__shop-sidebar ltn__right-sidebar--- ${isOpen ? 'show-sidebar' : ''}`}>
                <div className="sidebar-inner">
                    <button
                        className="close-sidebar-btn d-lg-none"
                        onClick={handleOverlayClick}
                    >
                        <i className="fas fa-times" />
                    </button>
                    <ClientWidget
                        publicUrl={publicUrl}
                        client={data?.client}
                        clientTypeIcon={data?.client?.client_type}
                    />
                    {data?.products_used.length > 0 && (
                        <TopRatedProductWidget
                            publicUrl={publicUrl}
                            products={data?.products_used}
                        />
                    ) }
                    <FormWidget projectTitle={data.title} projectLink={window.location.href} />
                </div>
            </aside>
        </div>
    );
});

export default SidebarDetails;